// removed by extract-text-webpack-plugin
module.exports = {"container":"_3ZfTE","image":"_1LsMp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RecurringDonations/PageSupportsRecurringDonations.scss
// module id = ./src/components/RecurringDonations/PageSupportsRecurringDonations.scss
// module chunks = 4